import React, { Component } from "react";
import moment from "moment";
import styled from "styled-components";

const Container = styled.div`
  float: left;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 10px;
  max-width: ${props => `${props.containerWidth}px`};
  margin-bottom: 10px;
`;
const Wrapper = styled.div`
  background-color: #fff;
  min-height: ${props => `${props.containerHeight}px`};
  position: relative;
  overflow: hidden;
  background-image: ${props => `url(${props.imageUrl})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.2);
  &:before {
    content: "";
    display: block;
    position: absolute;
    background-color: #000;
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
`;

const Header = styled.div`
  color: #fff;
  position: relative;
  font-family: "Oswald";
  opacity: 0.85;
  padding: 1em;
  float: left;
  font-size: 12px;
  &:before{
    content: '';
    display: table;
  }
  &:after{
    content: '';
    display: table;
    clear: both;
  }
}
`;
const Date = styled.div`
  float: left;
  font-size: 15px;
  font-weight: 100;
`;
const Content = styled.div`
  padding: 1em;
  position: relative;
  z-index: 1;
`;
const Title = styled.h3`
  font-family: "Oswald", "Open Sans", sans-serif;
  font-weight: 300;
  color: white;
  margin-top: 35px !important;
`;
const Summary = styled.p`
  font-family: "Open Sans";
  text-align: justify;
  font-size: 14px;
  margin: 0;
  color: white;
`;
export class NewsFullBackgroundCard extends Component {
  render() {
    const { news, newsNumber, containerHeight, containerWidth } = this.props;
    if (news.length === 0) return null;
    return news.items.slice(0, newsNumber).map((article, i) => (
      <Container key={i} containerWidth={containerWidth}>
        <Wrapper imageUrl={article.image.split("|")[0]} containerHeight={containerHeight}>
          <Header>
            <Date>
              <span className="day">
                {moment(article.created)
                  .locale("fr")
                  .fromNow()}
              </span>
            </Date>
          </Header>
          <Content>
            <Title>{article.title}</Title>
            <Summary>{article.description.split("...")[0]}...</Summary>
          </Content>
        </Wrapper>
      </Container>
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/News/NewsFullBackgroundCard/index.js